import { inject } from '@angular/core';
import { RedirectFunction, Router, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { LegacyReportDownloadComponent } from './legacy-report-download.component';

// Old VM Online (v10) emails sent deep links to a query-string page that no longer
// exists in v11, e.g. Property/Index?subview=Objections&assessmentNumber=167195&objectionId=7316
// This maps those old links onto the new routes so previously-sent emails keep working.
const redirectLegacyPropertyLink: RedirectFunction = ({ queryParamMap }) => {
	const router = inject(Router);

	const assessmentNumber = queryParamMap.get('assessmentNumber');
	const objectionId = queryParamMap.get('objectionId');
	const subview = queryParamMap.get('subview');

	if (!assessmentNumber) {
		return router.parseUrl('/search');
	}

	if (subview === 'Objections' && objectionId) {
		return router.createUrlTree(['/properties', assessmentNumber, 'objections', objectionId]);
	}

	return router.createUrlTree(['/properties', assessmentNumber]);
};

// The same old page was reached under a few different prefixes depending on the release.
const legacyPropertyIndexPaths = ['Property/Index', 'vm/Property/Index', 'VMOnline/Property/Index'];

// The old download links pointed at a synchronous download endpoint that no longer exists. The
// file itself still lives in S3, so LegacyReportDownloadComponent re-downloads it (via the KAI
// email-reports endpoint) using the id + filename carried on the old link, then lands the user on
// the reports list. AuthGuard makes sure they are logged in first (and the download is authenticated).
const legacyDownloadPaths = ['Download', 'vm/Download', 'VMOnline/Download'];

export const legacyRoutes: Routes = [
	...legacyPropertyIndexPaths.map((path) => ({
		path,
		redirectTo: redirectLegacyPropertyLink,
	})),
	...legacyDownloadPaths.map((path) => ({
		path,
		component: LegacyReportDownloadComponent,
		canActivate: [AuthGuard],
	})),
];
